export default {
  getPublicSurveyQuestions(state) {
    return state.questions;
  },
  getPracticeDetails(state) {
    return state.practiceDetails;
  },
}